import React from 'react'

/**
 * Workspace footer — Eventox Studios branding (visual only).
 */
const Footer = () => {
  return (
    <footer id="workspace-footer" className="ex-footer">
      <div className="brand-mark">
        <span>eventox</span>
        <span className="brand-slash text-gradient"> / </span>
        <span>Studios © {new Date().getFullYear()}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap', justifyContent: 'center' }}>
        <span>Venue Dashboard</span>
        <span>•</span>
        <span>All rights reserved</span>
      </div>
    </footer>
  )
}

export default Footer
